export default __webpack_public_path__ + "static/media/faq.eb4c6701.svg";